class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.hasResults = this.hasAttribute("data-predictive-search-has-results");

    this.results = this.querySelector("[data-predictive-search-results]");
    this.noResults = this.querySelector("[data-predictive-search-no-results]");
    this.footer = this.querySelector("[data-predictive-search-footer]");

    if (this.hasAttribute("data-predictive-search-without-faq")) {
      this.setFaqResults(false);
    }
  }

  setFaqResults(hasFaqResults) {
    const hasAnyResults = this.hasResults || hasFaqResults;
    this.noResults.classList.toggle("hidden", hasAnyResults);
    this.results.classList.toggle("hidden", !hasAnyResults);
    this.footer.classList.toggle("hidden", !hasAnyResults);
  }
}

customElements.define("predictive-search", PredictiveSearch);
